import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useOffersStore = defineStore('offers', () => {
    const allOfferRequests = ref({
        data: [],
        total: 0,
        per_page: 10,
        current_page: 1,
    });
    // Single offer request (object) loaded for detail page
    const offerRequest = ref(null);

    const reset = () => {
        allOfferRequests.value = { data: [], total: 0, per_page: 10, current_page: 1 };
        offerRequest.value = null;
    };

    const actions = {
        search: (params) => axios.get('/api/v1/offers', { params }),
        saveOfferIntake: (data) => axios.post('/api/v1/offers', data),
        saveMlsComparison: (hash, data) => axios.post(`/api/v1/offers/${hash}/mls-comparison`, data),
        updateMlsComparison: (hash, mlsHash, data) => axios.patch(`/api/v1/offers/${hash}/mls-comparison/${mlsHash}`, data),
        updateOfferIntake: (hash, data) => axios.post(`/api/v1/offers/${hash}/order-intake`, data),
        submitOfferForm: (hash, data) => axios.post(`/api/v1/offers/submit?hash=${hash}`, data),
        calculateCashOffer: (hash, data) => axios.post(`/api/v1/offers/${hash}/calculate-cash-offer`, data),
        requestCashOffer: (hash, data) => axios.post(`/api/v1/offers/request-cash-offer${hash ? `?hash=${hash}` : ''}`, data),
    };

    return {
        allOfferRequests,
        offerRequest,
        reset,
        ...actions
    };
});
